<template>
	<div style="padding: 20px;">
		<el-row :gutter="20">
			<el-col :span="18">
				<div class="centext-box">
					<div class="header">
						修改数据
					</div>
					<div style="padding: 30px;" class="form">
						<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px"
							class="demo-ruleForm" label-position="left">
							<el-form-item label="数据Key" prop="key">
								<el-input type="text" placeholder="请输入数据Key" disabled size="small" v-model="ruleForm.key"
									style="width: 400px;"></el-input>
							</el-form-item>
							<el-form-item label="数据值" prop="val">
								<el-input type="textarea" :rows="10" placeholder="请输入数据值" size="small"
									v-model="ruleForm.val" style="width: 400px;"></el-input>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" size="small" @click="submitForm('ruleForm')">确定</el-button>
							</el-form-item>
						</el-form>
					</div>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				id: null,
				ruleForm: {
					key: '',
					val: '',
					option: 'update'
				},
				rules: {
					key: [{
						required: true,
						message: '请输入数据key',
						trigger: 'change'
					}],
					val: [{
						required: true,
						message: '请输入数据值',
						trigger: 'blur'
					}],
				},
			}
		},
		created() {
			this.resetForm()
			this.getData()
		},
		props:{
			data_key:[String,Number]
		},
		methods: {
			getData(){
				this.$H.post('verify_center/v1_0_1.Data/Option',{
					key:this.data_key,
					option:'read'
				}).then(res => {
					if(res.data){
						this.ruleForm.key = this.data_key
						this.ruleForm.val = res.data.val
					}
				});
			},
			submitForm() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						this.$H.post('/verify_center/v1_0_1.Data/Option', this.ruleForm).then(res => {
							if (res.data) {
								this.$message.success('修改成功')
								this.$emit('back')
							}

						}).catch(err => {
							console.log(err)
							this.$emit('back')
						});
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			resetForm() {
				this.$nextTick(() => {
					this.$refs['ruleForm'].resetFields();
				})
			}
		}
	}
</script>

<style scoped>
	.centext-box {
		border-radius: 5px;
		background-color: rgb(66, 75, 79);
		color: #fff
	}

	.centext-box .header {
		font-size: 14px;
		border-bottom: 1px solid #000;

	}

	.form>>>.el-form-item__label {
		color: #fff !important;
	}

	.form>>>.el-input__inner {
		background-color: rgb(66, 75, 79);
		border: 1px solid #ccc !important;
		color: #fff;
	}

	.form>>>.el-radio__label {
		color: #fff;
	}

	.form>>>.el-textarea__inner {
		background-color: rgb(66, 75, 79);
		border: 1px solid #ccc !important;
		color: #fff;
	}
</style>